import React, { FormEvent, useState } from 'react';

import { t } from '@lingui/macro';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components/macro';

import { Button, Input, ParagraphMd } from '@olist/design-system';
import { tokens } from '@olist/design-system-tokens';

import { PageLayout } from 'components';
import { ButtonWrapper, Logos, Title } from 'components/general';
import { OlistEmail } from 'components/icons/appLogos';
import useMixPanel from 'hooks/use-mixpanel';

const CustomParagraphMd = styled(ParagraphMd)`
  margin-bottom: ${tokens.spacing[600]};
  text-align: center;
`;

export default function RequestRecovery() {
  const urlParams = new URLSearchParams(window.location.search);
  const clientId = urlParams.get('clientId') || '';

  const ACCOUNT_API_URL = process.env.REACT_APP_ACCOUNTS_API;
  const initialsValue = { email: '', clientId };
  const [values, setValues] = useState(initialsValue);
  const { track } = useMixPanel(false);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();

    const headers = {
      'Content-Type': 'application/json',
    };

    axios
      .post(`${ACCOUNT_API_URL}/v1/reset-user-password/`, JSON.stringify(values), { headers })
      .then(() => {
        navigate('/auth/request-recovery-sent', { state: { values } });
      })
      .catch(() => {
        navigate('/auth/request-recovery-sent', { state: { values } });
      });
  };

  const onChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = ev.target as HTMLInputElement;
    setValues({ ...values, [name]: value });
  };

  return (
    <PageLayout>
      <section>
        <Logos>
          <OlistEmail />
        </Logos>
        <Title>{t`forgot your password?`}</Title>

        <CustomParagraphMd>
          {t`Don't worry. Enter your email and receive password reset instructions.`}
        </CustomParagraphMd>
        <form onSubmit={handleSubmit}>
          <Input
            id="email"
            name="email"
            label="e-mail"
            required
            type="email"
            placeholder="email@email.com"
            onChange={onChange}
          />
          <ButtonWrapper>
            <Button fixed variation="primary" size="medium" type="submit">
              {t`redefine password`}
            </Button>
          </ButtonWrapper>
          <ButtonWrapper>
            <Button
              fixed
              variation="secondary"
              size="medium"
              onClick={() => {
                track('Request Recovery - Clicked on Return to Login');
                navigate('/auth/login');
              }}
            >
              {t`return`}
            </Button>
          </ButtonWrapper>
        </form>
      </section>
    </PageLayout>
  );
}
